import React, { Fragment } from "react";
import TreemapHolder from "./section1/treemapHolder";
// import GeoMapHolder from './section2/geomapHolder'
import TableHolder from "./section2/tableHolder";
const LiveAsset = props => {
  const { newPieData } = props;
  var newObj = {};

  for (let i in newPieData) {
    if (!newObj[newPieData[i]["style"]]) {
      newObj[newPieData[i]["style"]] = newPieData[i]["allocation"] * 1;
    } else {
      newObj[newPieData[i]["style"]] =
        parseFloat(newObj[newPieData[i]["style"]]) +
        parseFloat(newPieData[i]["allocation"]);
    }
  }
  return (
    <Fragment>
      <TreemapHolder TreeData={newObj} id={"Treemap1"} />
      {/* <GeoMapHolder /> */}
      <TableHolder TreeData={newObj} />
    </Fragment>
  );
};

export default LiveAsset;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/LiveAsset/LiveAsset.jsx